import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CollectionCompanyManagementList from '@/components/collection-company-management/list'

function CollectionCompanyManagementView() {

    const title = 'Správa svozových společností'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <CollectionCompanyManagementList />
            </CustomPaper>
        </>
    )
}

export default CollectionCompanyManagementView
